import axios from "axios";
import { attachAppAgent } from "@/api/appAgent";

const instance = axios.create({
  timeout: 10000,
});

attachAppAgent(instance);

function fetchLambda(params) {
  const lambdaUrl = process.env.VUE_APP_LAMBDA_URL;

  return instance.get(lambdaUrl, { params });
}

export { fetchLambda };
